import { useLocation } from "react-router-dom";

// Etichetta del ritorno in base alla schermata di provenienza REALE
export function labelForPath(pathname) {
  if (pathname.startsWith("/portafoglio-attivo")) return "Torna al Portafoglio Attivo";
  if (/^\/clienti\/.+/.test(pathname)) return "Torna al cliente";
  if (pathname.startsWith("/clienti")) return "Torna ai clienti";
  if (pathname.startsWith("/pipeline")) return "Torna alle pratiche";
  if (pathname.startsWith("/strumenti")) return "Torna ai calcolatori";
  return "Torna indietro";
}

// Stato di navigazione da allegare ai link verso le schede di dettaglio
export function useFromState() {
  const location = useLocation();
  return { from: { path: location.pathname + location.search, label: labelForPath(location.pathname) } };
}
